const firstValue = (...values) => values.find(value => value !== undefined && value !== null && value !== '');

export const buildSupportContext = ({
  explicitContext = {},
  storedContext = {},
  locationObject = typeof window !== 'undefined' ? window.location : {},
  viewport = typeof window !== 'undefined'
    ? { width: window.innerWidth, height: window.innerHeight }
    : {}
} = {}) => ({
  viewId: firstValue(explicitContext.viewId, storedContext.viewId),
  viewLabel: firstValue(explicitContext.viewLabel, storedContext.viewLabel),
  projectId: firstValue(explicitContext.projectId, storedContext.projectId),
  stepId: firstValue(explicitContext.stepId, storedContext.stepId),
  url: locationObject?.origin && locationObject?.pathname
    ? `${locationObject.origin}${locationObject.pathname}`
    : undefined,
  viewport: viewport?.width && viewport?.height
    ? `${viewport.width}x${viewport.height}`
    : undefined
});

export const formatSupportContext = (context = {}) => {
  const rows = [
    ['Side', context.viewLabel || context.viewId],
    ['Projekt-id', context.projectId],
    ['Trin', context.stepId],
    ['URL', context.url],
    ['Skærm', context.viewport]
  ].filter(([, value]) => value !== undefined && value !== null && value !== '');

  return ['Kontekst (automatisk)', ...rows.map(([label, value]) => `${label}: ${value}`)].join('\n');
};
